<template>
  <!-- All data are test and static for now, will need to change them for sure -->
  <div :class="[overallDivClass, overallDivClassCustom]">
    <div :class="[titleClass, titleCSSPropsStyle]">
      {{ fundType }}
    </div>
    <!-- need v-if or v-show for the condition to show or hide, and spouse name need to be dynamic here -->
    <div
      v-show="couplePledgeData !== undefined && couplePledgeData !== null"
      class="flex flex-row bg-[#FFFFFF] px-[16px] md:px-[20px] lg:px-[24px] py-[8px] md:py-[10px] lg:py-[12px] text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] leading-[1.25rem] md:leading-[1.375rem] lg:leading-[1.5rem]"
    >
      <div class="text-[1rem] md:text-[1.125rem] lg:text-[1.25rem]">&#128107;</div>
      <div class="ml-[8px] md:ml-[12px] lg:ml-[16px]">
        Pledging as a couple with
        <p class="wrap-break-word">
          {{
            secondaryPledge && mainPledgerName ? mainPledgerName : couplePledgeData?.partner_name
          }}
        </p>
      </div>
    </div>
    <!-- v-for, test with testData first which is basically static data -->
    <PledgeAccordian
      :table-data="pledgeData"
      title="Amount pledged"
      :selected-year="selectedYear"
    />
    <FulfillAccordian
      :table-data="fulfillData"
      title="Amount fulfilled"
      :selected-year="selectedYear"
    />
    <!-- <div
      v-if="
        (tableData?.month_1_commitment !== null ||
        tableData?.month_2_commitment !== null ||
        tableData?.month_3_commitment !== null ||
        tableData?.month_4_commitment !== null) && showPledgeMonth
      "
      v-for="(value, key) in tableData"
      :key="key"
    >
      <div
        class="w-full flex flex-row bg-[#F0F2F4]"
        v-show="!key.includes('one_time')"
      >
        <div :class="[cellClass]">
          {{
            key.includes("1")
              ? "Oct"
              : key.includes("2")
              ? "Nov"
              : key.includes("3")
              ? "Dec"
              : "Jan"
          }}
          {{ key.includes("4") ? selectedYear + 1 : selectedYear }}
        </div>
        <div :class="[cellClass]" :v-show="key.includes('one_time') === false">
          ${{
            Number.isNaN(value) || value === null || value === undefined
              ? 0
              : value
          }}
        </div>
      </div>
    </div> -->
    <!-- <div class="w-full flex flex-row">
      <div :class="[cellClass]">Amount fulfilled</div>
      <div :class="[cellClass]">$0</div>
    </div> -->
    <div
      class="w-full flex flex-row justify-between text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] leading-[1.25rem] md:leading-[1.375rem] lg:leading-[1.5rem] font-medium text-[#21201E] py-[12px] md:py-[14px] lg:py-[16px] pl-[16px] md:pl-[20px] lg:pl-[24px] pr-[40px] md:pr-[48px] lg:pr-[56px]"
    >
      <div>Percentage fulfilled</div>
      <div>{{ percentageFulfilled() }}%</div>
    </div>
  </div>
</template>

<script>
import PledgeAccordian from '../Common/PledgeAccordian.vue';
import FulfillAccordian from '../Common/FulfillAccordian.vue';
import { commitmentTotal } from '@/utils/bf-commitment-months';
export default {
  props: {
    TableTitle: {
      type: String,
    },
    titleCSSPropsStyle: {
      type: String,
    },
    overallDivClassCustom: {
      type: String,
    },
    fundType: {
      type: String,
      default: 'BF',
    },
    selectedYear: {
      type: Number,
      default: 2024,
    },
    pledgeData: {
      type: Object,
      default: {
        one_time_commitment: null,
        month_1_commitment: null,
        month_2_commitment: null,
        month_3_commitment: null,
        month_4_commitment: null,
        month_5_commitment: null,
      },
    },
    fulfillData: {
      type: Object,
    },
    secondaryPledge: {
      type: Boolean,
      default: false,
    },
    couplePledgeData: {
      type: Object,
      default: null,
    },
    mainPledgerName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      overallDivClass: 'border-separate border-2 rounded-lg w-full flex flex-col',
      titleClass:
        'flex-1 font-bold rounded-t-lg py-[12px] md:py-[14px] lg:py-[16px] pl-[16px] md:pl-[20px] lg:pl-[24px] text-[1.125rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1.5rem] md:leading-[1.625rem] lg:leading-[1.75rem]',
      cellClass: 'flex-1 pl-[16px] py-[12px]',
      showPledgeMonth: false,
      //Test data only, to be replaced by real data
      testData: [
        {
          Month: 'Nov 2024',
          Amount: '$6,000',
        },
        {
          Month: 'Dec 2024',
          Amount: '$4,000',
        },
        {
          Month: 'Jan 2025',
          Amount: '$5,000',
        },
        {
          Month: 'Feb 2025',
          Amount: '$5,000',
        },
      ],
    };
  },
  components: {
    PledgeAccordian,
    FulfillAccordian,
  },
  methods: {
    percentageFulfilled() {
      // One-time plus every month (five from BF2026).
      const pledgeSum = commitmentTotal(this.pledgeData);

      const fulfillSum =
        this.fulfillData?.reduce((sum, element) => sum + Number(element.amount), 0) ?? 0;

      // Cap percentage at 100%
      if (pledgeSum === 0) {
        return 0;
      }
      const percentage = Math.round((fulfillSum / pledgeSum) * 100);
      return Math.min(percentage, 100);
    },
  },
};
</script>
